import React from "react";
import AdditonalPersonalDetails from "./AddtionalForms/AdditionalPersonalDetails";
import EmergencyContactDetails from "./AddtionalForms/EmergencyDetails";
import PassportDetails from "./AddtionalForms/PassportDetails";
import FamilyDetails from "./AddtionalForms/FamilyDetails";
import BankAccountDetails from "./AddtionalForms/BankAccountDetails";
import AdditonalEducationDetails from "./AddtionalForms/EducationDetails/AdditionalEducationDetails";

const AdditionalDetailsPage = (props) => {
  const {
    selectedRoundData,
    qualificationData,
    SelectedFormState,
    EducationSelectHandler,
    onChangeHandler,
    NomineeDetailsHandler,
    countries,
    states,
    MaritalOptions,
    selectHandler,
    RemoveHandler,
    AddMoreHandler,
    interviewDetails,
    DateChangeHandler,
    onFileChange,
    openImageInTab,
    imageRemoveHandler,
    validationErrors,
    acctNumError,
    RequiredFields,
    setSelectedFormState,
    familyDependentChangeHandler,
    dependentDetailsHandler,
    dateHandlerString,
  } = props;

  return (
    <div>
      <AdditonalEducationDetails
        countries={countries}
        states={states}
        EducationSelectHandler={EducationSelectHandler}
        selectedRoundData={selectedRoundData}
        qualificationData={qualificationData}
        SelectedFormState={SelectedFormState}
        interviewDetails={interviewDetails}
        onFileChange={onFileChange}
        openImageInTab={openImageInTab}
        imageRemoveHandler={imageRemoveHandler}
        RequiredFields={RequiredFields}
        setSelectedFormState={setSelectedFormState}
      />

      <AdditonalPersonalDetails
        onChangeHandler={onChangeHandler}
        FormData={FormData}
        AddMoreHandler={AddMoreHandler}
        RemoveHandler={RemoveHandler}
        selectedRoundData={selectedRoundData}
        NomineeDetailsHandler={NomineeDetailsHandler}
        SelectedFormState={SelectedFormState}
        interviewDetails={interviewDetails}
        DateChangeHandler={DateChangeHandler}
        validationErrors={validationErrors}
      />

      <EmergencyContactDetails
        onChangeHandler={onChangeHandler}
        SelectedFormState={SelectedFormState}
        interviewDetails={interviewDetails}
        validationErrors={validationErrors}
      />

      <PassportDetails
        dateHandlerString={dateHandlerString}
        onChangeHandler={onChangeHandler}
        SelectedFormState={SelectedFormState}
        interviewDetails={interviewDetails}
        DateChangeHandler={DateChangeHandler}
      />

      <FamilyDetails
        dependentDetailsHandler={dependentDetailsHandler}
        familyDependentChangeHandler={familyDependentChangeHandler}
        onChangeHandler={onChangeHandler}
        SelectedFormState={SelectedFormState}
        FormData={FormData}
        selectHandler={selectHandler}
        MaritalOptions={MaritalOptions}
        AddMoreHandler={AddMoreHandler}
        RemoveHandler={RemoveHandler}
        NomineeDetailsHandler={NomineeDetailsHandler}
        interviewDetails={interviewDetails}
        DateChangeHandler={DateChangeHandler}
        selectedRoundData={selectedRoundData}
      />

      <BankAccountDetails
        onChangeHandler={onChangeHandler}
        SelectedFormState={SelectedFormState}
        interviewDetails={interviewDetails}
        validationErrors={validationErrors}
        acctNumError={acctNumError}
        RequiredFields={RequiredFields}
      />
    </div>
  );
};

export default AdditionalDetailsPage;
